/*

dev_startup_ecom_1.5.4

Moving to v1.5.5
changes: from v1.5.4 to v1.5.5

1. After admin login remove update shipping address page and go to --> products page.
2. Fix logout issue - after logout still showing loggedin

*/

import React from 'react';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

import Success from './pages/Success';
import ShoppingCart from './pages/ShoppingCart';
import OrderSummary from './pages/OrderSummary';
import Login from './pages/Login';
import Register from './pages/Register';
import ShippingAddress from './pages/ShippingAddress';
import ShippingRoute from './pages/ShippingRoute';
import ShippingDisplay from './pages/ShippingDisplay';
import Products from './pages/Products';
import AddProduct from './pages/admin/AddProduct';

import AdminOrdersPage from './pages/admin/AdminOrdersPage';
import CustomersPage from './pages/admin/CustomersPage';
import AdminMainPage from './pages/admin/AdminMainPage';
import ProductList from './pages/admin/ProductList';
import EditProduct from './pages/admin/EditProduct';

import ProductDetails from './components/ProductDetails';
import Footer from './components/Footer';
import MyOrders from './components/MyOrders';
import NotFound from './pages/NotFound';
import NavBar from './components/NavBar';
// import Docs from './components/Docs';
import PlanAndPrice from './components/PlanAndPrice';
import FixPrice from './components/FixPrice';
import StartupPricingPage from './components/StartupPricingPage';
import ProtectedRoute from './components/ProtectedRoute';
import SelectCheckout from './components/SelectCheckout';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

/* Client Dashboard */
import Dashboard from './pages/Dashboard';

function App() {
  const { authLoaded } = useAuth();
  const location = useLocation();

  const hideLayoutRoutes = [
    '/',
    '/login',
    '/register',
    '/forgot-password'
  ];

  const hideLayout =
    hideLayoutRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/reset-password/');

  if (!authLoaded) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <div
      className="app-wrapper"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      {!hideLayout && <NavBar />}

      <div style={{ flex: 1 }}>
        <Routes>

          {/* PUBLIC */}
          <Route path="/" element={<Login />} />
          <Route path="/products" element={<Products />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/planandprice" element={<PlanAndPrice />} />
          <Route path="/fixprice" element={<FixPrice />} />
          <Route path="/startupprice" element={<StartupPricingPage />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/cart" element={<ShoppingCart />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />

          {/* USER (NON-ADMIN) */}

          <Route
            path="/order-summary"
            element={
              <ProtectedRoute>
                <OrderSummary />
              </ProtectedRoute>
            }
          />

          <Route
            path="/selectcheckout"
            element={
              <ProtectedRoute>
                <SelectCheckout />
              </ProtectedRoute>
            }
          />

          <Route
            path="/shipping"
            element={
              <ProtectedRoute>
                <ShippingRoute />
              </ProtectedRoute>
            }
          />

          <Route
            path="/shippingaddress"
            element={
              <ProtectedRoute>
                <ShippingAddress />
              </ProtectedRoute>
            }
          />

          <Route
            path="/shipping/display"
            element={
              <ProtectedRoute>
                <ShippingDisplay />
              </ProtectedRoute>
            }
          />

          <Route
            path="/success"
            element={
              <ProtectedRoute>
                <Success />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-orders"
            element={
              <ProtectedRoute>
                <MyOrders />
              </ProtectedRoute>
            }
          />

          {/* ADMIN ONLY */}

          <Route
            path="/admin/orders"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminOrdersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/main"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminMainPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/customers"
            element={
              <ProtectedRoute adminOnly={true}>
                <CustomersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/addproduct"
            element={
              <ProtectedRoute adminOnly={true}>
                <AddProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="/productlist"
            element={
              <ProtectedRoute adminOnly={true}>
                <ProductList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/edit/:id"
            element={
              <ProtectedRoute adminOnly={true}>
                <EditProduct />
              </ProtectedRoute>
            }
          />

          {/* FALLBACK */}
          <Route path="*" element={<NotFound />} />

        </Routes>
      </div>

      {!hideLayout && <Footer />}
    </div>
  );
}

export default App;